export const SIGNUP_FORM_STORAGE_KEY = "signupFormData";

const NON_SECRET_SIGNUP_FIELDS = [
  "email",
  "displayName",
  "firstName",
  "lastName",
  "phoneNumber",
  "inviteCode",
];

export const sanitizePendingSignupFormData = (formData) => {
  if (!formData || typeof formData !== "object" || Array.isArray(formData)) {
    return {};
  }

  return NON_SECRET_SIGNUP_FIELDS.reduce((sanitized, field) => {
    if (Object.prototype.hasOwnProperty.call(formData, field)) {
      sanitized[field] = formData[field];
    }
    return sanitized;
  }, {});
};

export const writePendingSignupFormData = (formData, storage = window.sessionStorage) => {
  storage.setItem(
    SIGNUP_FORM_STORAGE_KEY,
    JSON.stringify(sanitizePendingSignupFormData(formData))
  );
};

export const readPendingSignupFormData = (storage = window.sessionStorage) => {
  const storedValue = storage.getItem(SIGNUP_FORM_STORAGE_KEY);
  if (!storedValue) return null;

  try {
    const sanitized = sanitizePendingSignupFormData(JSON.parse(storedValue));
    if (Object.keys(sanitized).length === 0) {
      storage.removeItem(SIGNUP_FORM_STORAGE_KEY);
    } else {
      // Rewriting on every read immediately removes credentials from legacy payloads.
      storage.setItem(SIGNUP_FORM_STORAGE_KEY, JSON.stringify(sanitized));
    }
    return sanitized;
  } catch {
    storage.removeItem(SIGNUP_FORM_STORAGE_KEY);
    return null;
  }
};

export const clearPendingSignupFormData = (storage = window.sessionStorage) => {
  storage.removeItem(SIGNUP_FORM_STORAGE_KEY);
};

export const clearPendingSignupState = (storage = window.sessionStorage) => {
  storage.removeItem(SIGNUP_FORM_STORAGE_KEY);
  storage.removeItem("googleSignupPending");
  storage.removeItem("signupInProgress");
};
